(function() {
    'use strict';
    //service must be lowercase since Plaid library attaches to window.Plaid
    angular.module('wbUtilities').provider('FPJS', [function () {

        var configDefaults = {
            // //fingerprintjs2 overrides all subsection config options if these are included
            // fonts: {
            //     // extendedJsFonts: true
            // },
            // excludes: {
            //     // userAgent: true
            // }
            excludes: {
                // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
                'enumerateDevices': true,
                // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
                'pixelRatio': true,
                // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
                'doNotTrack': true,
                // uses js fonts already
                'fontsFlash': true,
                // changes too often
                'availableScreenResolution': true,
            },

        };
        var init = false;
        var initDelay = 2000;

        /**
         * @param {Object} options
         * @returns {*}
         */
        this.init = function(options) {
            angular.extend(configDefaults, options);
        };

        this.$get = ['$timeout', '$q', '$window', function($timeout, $q, $window) {

            var fpObj = {
                components: false,
            };

            var initPromise = $q.defer();

            var Fingerprint2 = $window.Fingerprint2;

            if (!Fingerprint2) {
                console.log("Notice: Fingerprint2 is not defined");
                Fingerprint2 = {
                    getPromise: () => $q.when([]),
                    x64hash128: angular.noop
                }
            }

            fpObj.init = function() {
                $timeout(function() {
                    Fingerprint2.getPromise(configDefaults).then(function (components) {
                        fpObj.components = components;
                        initPromise.resolve();
                    });
                }, initDelay);
            };
            fpObj.init();

            /**
             *
             * @param extra Object
             * @param refresh Bool
             * @returns Promise
             */
            fpObj.generateData = function(extra = {}, refresh = false) {
                var options = angular.extend({}, configDefaults, extra);
                var fpPromise = $q.defer();

                initPromise.promise.then(function() {

                    if (fpObj.components && !refresh) {
                        fpPromise.resolve(fpObj.components);
                    } else {
                        Fingerprint2.getPromise(options).then(function (components) {
                            fpObj.components = components;
                            fpPromise.resolve(components);
                        }).catch(function (err) {
                            fpPromise.reject(err);
                        });
                    }

                });

                return fpPromise.promise;
            };

            fpObj.generateFingerprint = function(components=[]) {
                var value = components.map(function (component) { return component.value });
                return Fingerprint2.x64hash128(value.join(''), 31);
            };

            return fpObj;

        }];

        return this;

    }])
    // Initialization of module
    .run(['FPJS', function (FPJS) {
        //just needs to be injected once to start the init
    }]);

})();
